"use client";

import { ChevronDown } from "lucide-react";
import { lpCopy, type LpAudience } from "@/data/lpCopy";

interface Props {
  audience: LpAudience;
}

export default function FaqSection({ audience }: Props) {
  const faqs = lpCopy[audience].faq;

  return (
    <section className="py-20" id="faq">
      <div className="max-w-[1100px] mx-auto px-6 md:px-12">
        <div className="mb-16">
          <h2 className="text-2xl md:text-4xl font-bold mb-4">よくある質問</h2>
          <p className="font-bold md:text-xl">
            サービスのご利用にあたって気になる点をご確認ください
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq) => (
            <details
              key={faq.question}
              className="faq-item group bg-white rounded-2xl border border-border overflow-hidden"
            >
              <summary className="flex justify-between items-center p-5 md:p-6 cursor-pointer hover:bg-[#FDF9F8] transition-colors">
                <div className="flex items-center gap-3 md:gap-4">
                  <span className="text-primary font-bold text-lg">Q.</span>
                  <span className="font-bold text-[15px] md:text-[16px] text-on-surface">
                    {faq.question}
                  </span>
                </div>
                <ChevronDown className="w-5 h-5 text-on-surface-variant/40 group-open:rotate-180 transition-transform" />
              </summary>
              <div className="px-6 pb-6 pt-2">
                <div className="flex gap-4">
                  <span className="text-on-surface-variant/40 font-bold text-lg">
                    A.
                  </span>
                  <p className="text-on-surface-variant leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
